import React from 'react';
import { Server, Database, Brain, ChevronRightIcon } from 'lucide-react';
export function RoadmapSlide() {
  const phases = [{
    phase: 1,
    title: 'Operational Foundation',
    color: '#22C55E',
    icon: <Server className="w-5 h-5" data-id="element-466" />,
    description: 'Standardize delivery operations across all fleets',
    actions: ['Deploy Pair2 FMS (IoT devices, driver app, web portal)', 'Onboard companies and drivers', 'Enable real-time tracking and control']
  }, {
    phase: 2,
    title: 'National Data Integration',
    color: '#3B82F6',
    icon: <Database className="w-5 h-5" data-id="element-467" />,
    description: 'Integrate all delivery platforms into a unified data layer',
    actions: ['Mandatory integration with aggregators and marketplaces', 'Real-time order data ingestion', 'Data enrichment with driver, vehicle, and tracking data']
  }, {
    phase: 3,
    title: 'Intelligence & Governance',
    color: '#F59E0B',
    icon: <Brain className="w-5 h-5" data-id="element-468" />,
    description: 'Enable advanced monitoring, automation, and decision-making',
    actions: ['AI-powered analytics and anomaly detection', 'Centralized monitoring for authorities', 'Policy enforcement and optimization']
  }];
  return <div className="flex flex-col w-screen h-screen overflow-hidden bg-white text-[#1a1a2e] px-8 py-6" data-id="element-469">
      {/* Top Header */}
      <div className="flex justify-between items-start shrink-0" data-id="element-470">
        <img src="https://cdn.magicpatterns.com/uploads/wGUVVF9ppu2J6VxJ2kpoN3/Pair2_Logo.png" alt="Pair2 Logo" className="h-8 w-auto object-contain" data-id="element-471" />
      </div>

      {/* Title */}
      <div className="text-center shrink-0 mb-6 mt-2" data-id="element-472">
        <span className="text-xs font-semibold text-[#2EBCB0] uppercase tracking-widest" data-id="element-473">
          Execution Plan
        </span>
        <h1 className="text-[1.5rem] font-bold text-[#1a1a2e] mt-1" data-id="element-474">
          Implementation Roadmap
        </h1>
      </div>

      {/* Roadmap Content */}
      <div className="flex-grow flex items-center justify-center max-w-7xl mx-auto w-full" data-id="element-475">
        <div className="w-full flex items-stretch gap-0 relative" data-id="element-476">
          {/* Background timeline line */}
          <div className="absolute top-[2.75rem] left-[3%] right-[3%] h-[3px] bg-gray-100 z-0 rounded-full" data-id="element-477" />
          {/* Animated progress line */}
          <div className="absolute top-[2.75rem] left-[3%] right-[3%] h-[3px] z-0 rounded-full overflow-hidden" data-id="element-478">
            <div className="h-full w-full bg-gradient-to-r from-[#22C55E] via-[#3B82F6] to-[#F59E0B] opacity-30" data-id="element-479" />
          </div>

          {phases.map((p, idx) => <div key={idx} className="flex-1 flex flex-col items-center relative z-10" data-id="element-480">
              {/* Phase circle on timeline */}
              <div className="flex items-center justify-center mb-6" data-id="element-481">
                <div className="w-[5.5rem] h-[5.5rem] rounded-full flex flex-col items-center justify-center shadow-lg border-4 border-white relative" style={{
              backgroundColor: p.color
            }} data-id="element-482">
                  <span className="text-white" data-id="element-483">{p.icon}</span>
                  <span className="text-white text-[0.6rem] font-bold uppercase tracking-wider mt-0.5" data-id="element-484">
                    Phase {p.phase}
                  </span>
                </div>
              </div>

              {/* Connector arrow between phases */}
              {idx < phases.length - 1 && <div className="absolute top-[2.75rem] right-0 translate-x-1/2 -translate-y-1/2 z-20" data-id="element-485">
                  <ChevronRightIcon className="w-5 h-5 text-gray-300" data-id="element-486" />
                </div>}

              {/* Card */}
              <div className="w-full px-3" data-id="element-487">
                <div className="rounded-2xl p-5 h-full flex flex-col" style={{
              backgroundColor: `${p.color}08`,
              border: `1px solid ${p.color}20`
            }} data-id="element-488">
                  {/* Title */}
                  <h3 className="font-bold text-[0.95rem] text-[#1a1a2e] leading-tight mb-2 text-center" data-id="element-489">
                    {p.title}
                  </h3>

                  {/* Description */}
                  <p className="text-[0.75rem] text-gray-500 leading-snug mb-5 text-center" data-id="element-490">
                    {p.description}
                  </p>

                  {/* Key Actions */}
                  <div className="bg-white rounded-xl p-4 mt-auto shadow-sm" data-id="element-491">
                    <h4 className="text-[0.6rem] font-bold uppercase tracking-wider mb-3" style={{
                  color: p.color
                }} data-id="element-492">
                      Key Actions
                    </h4>
                    <ul className="space-y-2.5" data-id="element-493">
                      {p.actions.map((action, aIdx) => <li key={aIdx} className="flex items-start gap-2" data-id="element-494">
                          <div className="w-1.5 h-1.5 rounded-full mt-1.5 shrink-0" style={{
                      backgroundColor: p.color
                    }} data-id="element-495" />
                          <span className="text-[0.75rem] text-gray-700 leading-snug" data-id="element-496">
                            {action}
                          </span>
                        </li>)}
                    </ul>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>

      {/* Bottom Tagline */}
      <div className="text-center shrink-0 mt-6" data-id="element-497">
        <p className="text-[0.85rem] italic text-gray-500 font-medium" data-id="element-498">
          "A phased approach to building a fully controlled and intelligent
          national delivery ecosystem."
        </p>
      </div>
    </div>;
}